const VIDEO_PROXY_ENDPOINT = 'https://video-proxy.wu.elfsightcompute.com';

export function getVideoProxyfied(videoURL: string, widgetToken: string) {
  const proxyURL = new URL(VIDEO_PROXY_ENDPOINT);

  proxyURL.searchParams.append('url', videoURL);
  proxyURL.searchParams.append('cache', '1');
  proxyURL.searchParams.append('widgetToken', widgetToken);

  return proxyURL.toString();
}
